import { getCurrentContractAddresses } from "src/configs/address";
import { environment } from "src/configs/constance";
import ABI from "src/contract-logic/abis/Bridge/SideCollectionABI.json";
import { NETWORKS } from "src/configs/connection-config";
import Web3 from "web3";

const { SIDE_COLLECTION } = getCurrentContractAddresses();
var contractReader = null;

function getContractReader() {
  if (!contractReader) {
    const web3Reader =
      environment == "mainnet" ? new Web3(NETWORKS.ETH_MAINNET.rpcUrls[0]) : new Web3(NETWORKS.SEPOLIA.rpcUrls[0]);
    contractReader = new web3Reader.eth.Contract(ABI, SIDE_COLLECTION);
  }
  if (!contractReader) {
    throw new Error("Failed to create nft-collection contract reader");
  }
  return contractReader;
}

async function getBalance(ownerAddress) {
  const balance = await getContractReader().methods.balanceOf(ownerAddress).call();
  return parseInt(balance);
}
async function totalSupply() {
  const balance = await getContractReader().methods.totalSupply().call();
  return parseInt(balance);
}

export default {
  ADDRESS: SIDE_COLLECTION,
  ABI,
  getBalance,
  totalSupply,
};
